import { User } from '@guiker/base-entity'

export enum RepresentativeRole {
  EDITOR = 'EDITOR',
}

export type Representative = User & {
  roles: RepresentativeRole[]
}
